import { createRef } from 'react';

export const PlayersRef = createRef<any>();
